module.exports = __webpack_public_path__ + "img/m1-screenshot-09_t.a07f00bf.jpg";